import React, { useEffect, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { Dropdown } from '@tcc/crate';
import { getMessage } from '@tcc/i18n';
import { mapTags } from '../../../../utils/regionUtils';
import { useAppSelector } from '../../../../utils';

import { reqTags } from '../../../../actions/scoutingActions';
import styles from '../RegionNoteForm.css';
import { Activity } from '../../../../types';

type RegionNoteFormTagsProps = {
  activity?: Activity;
  selectedTags: string[];
  setSelectedTags: (Iterable) => void;
};

export const RegionNoteFormTags = ({
  activity,
  selectedTags,
  setSelectedTags
}: RegionNoteFormTagsProps) => {
  const dispatch = useDispatch();
  const { tags: tagOptions } = useAppSelector(state => state.scouting);
  const initialTags = useMemo(() => activity?.tags ?? [], [activity?.tags]);

  // request tags from API on first render
  useEffect(() => {
    dispatch(reqTags());
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  // update state when tags are fetched and/or the activity prop tags field has been updated
  useEffect(() => {
    setSelectedTags(mapTags(tagOptions, initialTags, true));
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [tagOptions, initialTags]);

  return (
    <div className={styles.tagContainer} data-test-id="region-note-form-dropdown-tags">
      <Dropdown
        className={styles.regionNoteTags}
        label={getMessage('regionNote.form.tags')}
        multiselect
        options={tagOptions}
        placeholder={getMessage('regionNote.form.searchTags')}
        searchPlaceholder={getMessage('regionNote.form.searchTags')}
        searchable
        selectedId={selectedTags}
        setValue={selections => {
          setSelectedTags(selections.map(selection => selection.id))
        }}
      />
    </div>
  );
};
